import { useState, useEffect } from 'react'

export function Loader({ waitTime = 200 }: { waitTime?: number }) {
  const [idle, setIdle] = useState(true)

  useEffect(() => {
    if (idle) {
      const timeout = setTimeout(() => {
        setIdle(false)
      }, waitTime)
      return () => clearTimeout(timeout)
    }
  })

  if (idle) {
    return null
  } else {
    return <div>Laster...</div>
  }
}
